/* AXV — scroll reveal, count-up, light/dark toggle, hero slides, header, smooth scroll */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  var revealObserver = null;
  function initReveal() {
    var nodes = document.querySelectorAll('[data-axv-reveal]:not(.axv-reveal-ready)');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); revealObserver.unobserve(en.target); }
        });
      }, { threshold: 0.12 });
    }
    nodes.forEach(function (n, i) {
      n.classList.add('axv-reveal-ready');
      n.style.transitionDelay = (i % 4) * 80 + 'ms';
      revealObserver.observe(n);
    });
  }

  /* ---------- Count-up for hero stats ---------- */
  function initCountUp() {
    document.querySelectorAll('[data-axv-count]:not([data-axv-done])').forEach(function (el) {
      el.setAttribute('data-axv-done', '1');
      var m = el.textContent.trim().match(/^(\D*)(\d+)(\D*)$/);
      if (!m || reduceMotion) return;
      var prefix = m[1], target = parseInt(m[2], 10), suffix = m[3], start = null, dur = 1800;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1), eased = 1 - Math.pow(1 - p, 4);
        el.textContent = prefix + Math.floor(eased * target) + suffix;
        if (p < 1) requestAnimationFrame(step); else el.textContent = prefix + target + suffix;
      }
      setTimeout(function () { requestAnimationFrame(step); }, 300);
    });
  }

  /* ---------- Light / dark toggle ---------- */
  function isLight() { return document.documentElement.classList.contains('axv-light'); }
  function syncToggles() {
    var on = isLight();
    document.querySelectorAll('.axv-theme-toggle').forEach(function (b) {
      b.setAttribute('aria-label', on ? 'Switch to dark mode' : 'Switch to light mode');
    });
    document.querySelectorAll('[data-axv-theme]').forEach(function (b) {
      var active = (b.getAttribute('data-axv-theme') === 'light') === on;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  function setLight(on) {
    document.documentElement.classList.toggle('axv-light', on);
    try { localStorage.setItem('axv-theme', on ? 'light' : 'dark'); } catch (e) {}
    syncToggles();
  }
  var TOGGLE_ICONS =
    '<span class="svg-wrapper">' +
    '<svg class="icon axv-icon-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="4.5"/><path d="M12 1.5v2.5M12 20v2.5M4.6 4.6l1.8 1.8M17.6 17.6l1.8 1.8M1.5 12H4M20 12h2.5M4.6 19.4l1.8-1.8M17.6 6.4l1.8-1.8"/></svg>' +
    '<svg class="icon axv-icon-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M20.5 13.2A8.5 8.5 0 1 1 10.8 3.5a6.6 6.6 0 0 0 9.7 9.7z"/></svg>' +
    '</span>';
  function initToggle() {
    var icons = document.querySelector('.header__icons');
    if (icons && !icons.querySelector('.axv-theme-toggle')) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'header__icon axv-theme-toggle link focus-inset';
      b.innerHTML = TOGGLE_ICONS;
      var loc = icons.querySelector('.desktop-localization-wrapper');
      if (loc) loc.insertAdjacentElement('afterend', b);
      else icons.insertBefore(b, icons.firstChild);
    }
    syncToggles();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.axv-theme-toggle, [data-axv-theme]');
    if (!t) return;
    if (t.hasAttribute('data-axv-theme')) setLight(t.getAttribute('data-axv-theme') === 'light');
    else setLight(!isLight());
  });

  /* ---------- Hero slides (crossfade images / videos) ---------- */
  function initSlides() {
    document.querySelectorAll('[data-axv-slides]:not([data-axv-init])').forEach(function (el) {
      el.setAttribute('data-axv-init', '1');
      var slides = Array.prototype.slice.call(el.querySelectorAll('.axv-hero__slide'));
      var hero = el.closest('.axv-hero');
      var dots = hero ? Array.prototype.slice.call(hero.querySelectorAll('.axv-hero__dot')) : [];
      var interval = (parseInt(el.getAttribute('data-interval'), 10) || 6) * 1000;
      var index = 0, timer = null, paused = false;

      function syncVideos() {
        slides.forEach(function (s, i) {
          var v = s.querySelector('video');
          if (!v) return;
          if (i === index) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }
      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === index); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === index); });
        syncVideos();
      }
      function start() {
        stop();
        if (slides.length < 2 || reduceMotion) return;
        timer = setInterval(function () {
          if (!document.body.contains(el)) { stop(); return; }
          if (paused || document.hidden) return;
          show(index + 1);
        }, interval);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
      el._axvShow = function (k) { paused = true; show(k); };
      el._axvResume = function () { paused = false; };
      syncVideos();
      start();
    });
  }
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest && e.target.closest('.axv-hero__slide');
    if (!slide) return;
    var wrap = slide.parentElement;
    var all = wrap.querySelectorAll('.axv-hero__slide');
    for (var i = 0; i < all.length; i++) if (all[i] === slide && wrap._axvShow) wrap._axvShow(i);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var slide = e.target && e.target.closest && e.target.closest('.axv-hero__slide');
    if (slide && slide.parentElement._axvResume) slide.parentElement._axvResume();
  });

  /* ---------- Header: transparent over hero, solid on scroll ---------- */
  var headerBound = false;
  function updateHeader() {
    var root = document.documentElement;
    var first = document.querySelector('#MainContent > .shopify-section:first-child');
    var hasHero = !!(first && first.querySelector('.axv-hero'));
    if (!hasHero) {
      root.style.removeProperty('--axv-header-alpha');
      root.classList.remove('axv-scrolled');
      return;
    }
    var y = window.scrollY || window.pageYOffset;
    root.style.setProperty('--axv-header-alpha', (Math.min(y / 120, 1) * 0.92).toFixed(3));
    root.classList.toggle('axv-scrolled', y >= 100);
  }
  function initHeader() {
    updateHeader();
    if (headerBound) return;
    headerBound = true;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { updateHeader(); ticking = false; });
    }, { passive: true });
  }

  /* ---------- Smooth scroll (mouse wheel + in-page anchors) ---------- */
  var smoothInit = false;
  function initSmoothScroll() {
    var root = document.documentElement;
    if (smoothInit || root.getAttribute('data-axv-smooth') !== 'true' || reduceMotion) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;
    smoothInit = true;
    root.classList.add('axv-smooth');

    var target = window.scrollY, current = target, raf = null;
    function maxScroll() { return Math.max(0, root.scrollHeight - window.innerHeight); }
    function tick() {
      var diff = target - current;
      if (Math.abs(diff) < 0.5) { current = target; window.scrollTo(0, current); raf = null; return; }
      current += diff * 0.12;
      window.scrollTo(0, current);
      raf = requestAnimationFrame(tick);
    }
    function glideTo(y) {
      if (!raf) current = window.scrollY;
      target = Math.max(0, Math.min(maxScroll(), y));
      if (!raf) raf = requestAnimationFrame(tick);
    }
    function insideScrollable(el) {
      while (el && el !== document.body && el !== root) {
        var cs = window.getComputedStyle(el);
        if (/(auto|scroll)/.test(cs.overflowY) && el.scrollHeight > el.clientHeight + 1) return true;
        el = el.parentElement;
      }
      return false;
    }

    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey || e.defaultPrevented || e.deltaY === 0) return;
      if (document.body.classList.contains('overflow-hidden') || root.classList.contains('overflow-hidden')) return;
      if (document.querySelector('dialog[open]')) return;
      if (insideScrollable(e.target)) return;
      e.preventDefault();
      var dy = e.deltaMode === 1 ? e.deltaY * 32 : e.deltaMode === 2 ? e.deltaY * window.innerHeight : e.deltaY;
      if (!raf) { current = window.scrollY; target = current; }
      glideTo(target + dy);
    }, { passive: false });

    window.addEventListener('scroll', function () { if (!raf) { current = target = window.scrollY; } }, { passive: true });

    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || e.defaultPrevented) return;
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var dest = document.getElementById(id);
      if (!dest) return;
      e.preventDefault();
      var offset = parseInt(window.getComputedStyle(root).getPropertyValue('--header-height'), 10) || 0;
      glideTo(dest.getBoundingClientRect().top + window.scrollY - offset);
    });
  }

  /* ---------- Cart drawer: discount code ---------- */
  function refreshDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || typeof cd.getSectionsToRender !== 'function') return Promise.resolve();
    var list = cd.getSectionsToRender();
    return fetch(window.location.pathname + '?sections=' + list.map(function (s) { return s.id; }).join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        list.forEach(function (s) {
          var html = sections[s.id];
          if (!html) return;
          var target = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          if (!target) return;
          var src = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector || '.shopify-section');
          if (src) target.innerHTML = src.innerHTML;
        });
        var ov = cd.querySelector('#CartDrawer-Overlay');
        if (ov) ov.addEventListener('click', cd.close.bind(cd));
      });
  }
  function discountShown(cart, code) {
    var c = code.toLowerCase(), titles = [];
    (cart.cart_level_discount_applications || []).forEach(function (a) { titles.push(String(a.title).toLowerCase()); });
    (cart.items || []).forEach(function (i) { (i.discounts || []).forEach(function (d) { titles.push(String(d.title).toLowerCase()); }); });
    return titles.indexOf(c) > -1;
  }
  function refreshCartPage() {
    return fetch(window.location.href, { cache: 'no-store', headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector('#MainContent');
        var dst = document.querySelector('#MainContent');
        if (src && dst) dst.innerHTML = src.innerHTML;
      });
  }
  function applyDiscountCode(code, inDrawer) {
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    // 1) try the cart API, 2) save the code for checkout through the discount link
    return fetch('/cart/update.js', { method: 'POST', headers: headers, body: JSON.stringify({ discount: code }) })
      .catch(function () {})
      .then(function () { return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}); })
      .then(function () { return inDrawer ? refreshDrawer() : refreshCartPage(); })
      .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) { return discountShown(cart, code); });
  }
  function submitDiscount(box) {
    if (!box) return;
    var input = box.querySelector('[data-axv-discount-input]');
    var btn = box.querySelector('[data-axv-discount-apply]');
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    var inDrawer = !!box.closest('cart-drawer');
    btn.disabled = true;
    applyDiscountCode(code, inDrawer).then(function (shown) {
      var msg = document.querySelector((inDrawer ? 'cart-drawer' : '#MainContent') + ' [data-axv-discount-msg]');
      if (msg) {
        msg.textContent = shown ? msg.getAttribute('data-applied') : msg.getAttribute('data-saved');
        msg.classList.toggle('is-ok', !!shown);
      }
    }).catch(function () {
      btn.disabled = false;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-axv-discount-apply]');
    if (b) submitDiscount(b.closest('.axv-disc'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-axv-discount-input]')) {
      e.preventDefault();
      submitDiscount(e.target.closest('.axv-disc'));
    }
  });

  function init() { initReveal(); initCountUp(); initToggle(); initSlides(); initHeader(); initSmoothScroll(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initReveal(); initCountUp(); initToggle(); initSlides(); updateHeader(); });
})();
